import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

/**
 * Shell Layout module.
 * Depends on: kernel.commands, runtime.workspace
 */
export class LayoutModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.LAYOUT;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [
    MODULE_NAMES.KERNEL.COMMANDS,
    MODULE_NAMES.RUNTIME.WORKSPACE
  ];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const commandsState = registry.getState(MODULE_NAMES.KERNEL.COMMANDS);
    const workspaceState = registry.getState(MODULE_NAMES.RUNTIME.WORKSPACE);

    if (commandsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'kernel.commands must be bootstrapped before shell.layout'
      );
    }
    if (workspaceState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'runtime.workspace must be bootstrapped before shell.layout'
      );
    }

    if (!punica.shell?.Layout?.manager) {
      throw new Error('Layout manager not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    // Layout module is ready to use after bootstrap
  }
}
